// import axios from 'axios';

// const baseURL = 'https://brands-blogs-5bd4a6b50a83.herokuapp.com';

// export const apiHandle = axios.create({
//   baseURL,
//   headers: {
//     'Content-Type': 'multipart/form-data',
//   },
// });

// axios.defaults.timeout = 15000;

import axios from "axios";
import { save_tokens_constant, session_expired } from "../utils/contants/asyncStatus";

export const baseURL = "https://dots-backend-app-782ae8400683.herokuapp.com/";
// export const baseURL = "http://192.168.100.14:5001/";
export const apiHandle = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

axios.defaults.timeout = 15000;

export const exit_session = async () => {
  try {
    localStorage.removeItem(save_tokens_constant.AUTH);
    localStorage.setItem(session_expired, true);
    await localStorage.clear();
    window.location.reload();
  } catch (error) {
    console.error("Failed to clear data:", error);
  }
};
// const storedToken = JSON.parse(localStorage.getItem(save_tokens_constant.AUTH));

apiHandle.interceptors.request.use(async (req) => {
  const auth_token = localStorage.getItem(save_tokens_constant.AUTH) || "";
  if (auth_token) {
    req.headers.Authorization = `Bearer ${auth_token}`;
  }

  return req;
});
